import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { black } from 'constants/colors';

export const ThinkSeedSmallCardWrapper = styled.div`
  width: 15rem;
  display: inline-block;
  vertical-align: top;
  margin-right: 1rem;
  border-radius: 1.5rem;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border: 0.1rem solid #e9e9e9;

  .header {
    height: 14.7rem;
    background-size: cover;
    background-color: #eee;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: relative;

    .opacity {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.47);
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      border-radius: 1.5rem 1.5rem 0 0;
    }

    .title {
      position: relative;
      z-index: 2;
      padding: 1rem;
      font-family: ${RalewayFont.regularFamily};
      font-size: 1.3rem;
      color: #fff;
    }

    .countdown {
<<<<<<< HEAD:src/components/Cards/ThinkSeedSmallCard/components/styles.js
=======
      font-family: ${RalewayFont.boldFamily};
>>>>>>> searchStep:src/components/ThinkSeedSmallCard/components/styles.js
      font-size: 1.5rem;
      padding: 0 1rem;
      position: relative;
      z-index: 3;
    }
  }

  &.disabled {
    .header {
      filter: grayscale(100%);
    }
  }

  .body {
    background-color: #fff;
    padding: 1rem;

    > div {
      color: ${black};
      font-family: ${RalewayFont.regularFamily};
      font-size: 1.6rem;
      line-height: 1.9rem;
      white-space: normal;
      height: 4.95rem;
      overflow: hidden;
    }
  }

  .footer {
    background-color: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Cards/ThinkSeedSmallCard/components/styles.js